import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import TicketReportList from '../../../components/reports/tickets/TicketReportList'
import TicketLifeCycleReport from '../../../components/reports/tickets/SelectedTicket/TicketLifeCycleReport'
import IssueTypeWiseTatReport from '../../../components/reports/tickets/SelectedTicket/IssueTypeWiseTatReport'
import SubIssueTypeWiseTatReport from '../../../components/reports/tickets/SelectedTicket/SubIssueTypeWiseTatReport'
import DepartmentWiseTatReport from '../../../components/reports/tickets/SelectedTicket/DepartmentWiseTatReport'
import StatusLevelAuditReport from '../../../components/reports/tickets/SelectedTicket/StatusLevelAuditReport'
import AuditTicktetReport from '../../../components/reports/tickets/SelectedTicket/AuditTicktetReport'
import LatestStatusReport from '../../../components/reports/tickets/SelectedTicket/LatestStatusReport'

//  report components
import TicketLifeCycleReport1 from '../../../components/reports/tickets/SelectedTicket/TicketLifeCycleReport1'
import IssueTypeWiseTatReport1 from '../../../components/reports/tickets/SelectedTicket/IssueTypeWiseTatReport1'
import SubIssueTypeWiseTatReport1 from '../../../components/reports/tickets/SelectedTicket/SubIssueTypeWiseTatReport1'
import DepartmentWiseTatReport1 from '../../../components/reports/tickets/SelectedTicket/DepartmentWiseTatReport1'
import StatusLevelAuditReport1 from '../../../components/reports/tickets/SelectedTicket/StatusLevelAuditReport1'
import AuditTicktetReport1 from '../../../components/reports/tickets/SelectedTicket/AuditTicktetReport1'
import LatestStatusReport1 from '../../../components/reports/tickets/SelectedTicket/LatestStatusReport1'


import TicketSlVolumeReport from '../../../components/reports/tickets/SelectedTicket/TicketSlVolumeReport'
import TicketTagSlReport from '../../../components/reports/tickets/SelectedTicket/TicketTagSlReport'
import TicketPrioritySlReport from '../../../components/reports/tickets/SelectedTicket/TicketPrioritySlReport'
import TicketWorkflowSlReport from '../../../components/reports/tickets/SelectedTicket/TicketWorkflowSlReport'

const TicketRoute = () => {
    const tenant = localStorage.getItem('circleone-user')?.toLowerCase()
const isMdIndia = tenant === 'mdindia' || tenant === 'stage' || tenant === 'victorinox' || tenant === 'cslfinance' || tenant === 'knabfinance' || tenant === 'mdindiadcinvoice'  || tenant === 'csquare' || tenant === 'payswiffibl' || tenant === 'payswiffstage'  || tenant === 'briezi' ;

    return (
        <Routes>

            <Route
                path='/reports-list'
                element={
                    <>
                     <TicketReportList/>
                    </>
                }
            />

            <Route
                path='/ticket-life-cycle-report'
                element={
                    isMdIndia ? <TicketLifeCycleReport /> : <TicketLifeCycleReport1 />
                }
            />
            <Route
                path='/issue-type-wise-tat-report'
                element={
                    isMdIndia ? <IssueTypeWiseTatReport /> : <IssueTypeWiseTatReport1 />
                }
            />
            <Route
                path='/sub-issue-type-wise-tat-report'
                element={
                    isMdIndia ? <SubIssueTypeWiseTatReport /> : <SubIssueTypeWiseTatReport1 />
                }
            />
            <Route
                path='/department-wise-tat-report'
                element={
                    isMdIndia ? <DepartmentWiseTatReport /> : <DepartmentWiseTatReport1 />
                }
            />
            <Route
                path='/status-level-audit-report'
                element={
                    isMdIndia ? <StatusLevelAuditReport /> : <StatusLevelAuditReport1 />
                }
            />
            <Route
                path='/audit-ticket-report'
                element={
                    isMdIndia ? <AuditTicktetReport /> : <AuditTicktetReport1 />
                }
            />
            <Route
                path='/latest-status-report'
                element={
                    isMdIndia ? <LatestStatusReport /> : <LatestStatusReport1 />
                }
            />


<Route
                path='/ticket-sl-volume-report'
                element={
                    <>
                        <TicketSlVolumeReport />
                    </>
                }
            />
            <Route
                path='/ticket-tag-sl-report'
                element={
                    <>
                        <TicketTagSlReport />
                    </>
                }
            />
            <Route
                path='/ticket-priority-sl-report'
                element={
                    <>
                        <TicketPrioritySlReport />
                    </>
                }
            />
            <Route
                path='/ticket-workflow-sl-report'
                element={
                    <>
                        <TicketWorkflowSlReport />
                    </>
                }
            />
            <Route path='/customer-tag-sl-report' element={<Navigate to='/ticket-tag-sl-report' replace />} />
            <Route path='/priority-sl-report' element={<Navigate to='/ticket-priority-sl-report' replace />} />
            <Route path='/workflow-sl-report' element={<Navigate to='/ticket-workflow-sl-report' replace />} />

            <Route index element={<Navigate to='/ticket/reports-list' />} />

        </Routes >
    )
}

export default TicketRoute
